import type { ServiceOption } from "./ArticleTypes";
export function setServiceOption(
	serviceOptionId: string,
	selected: boolean,
	serviceOptions: Array<ServiceOption>,
): Array<ServiceOption> {
	const serviceOption = serviceOptions.find((option) => option.id === serviceOptionId);

	if (!serviceOption) {
		return serviceOptions;
	}

	const types = serviceOption.types;

	if (types && types.length > 0 && selected) {
		// deselect all other options with a type in common with the newly selected option
		return serviceOptions.map((option) =>
			option.types && option.types.some((type) => types.includes(type))
				? { ...option, selected: option.id === serviceOptionId }
				: option,
		);
	} else {
		return serviceOptions.map((option) =>
			option.id === serviceOptionId ? { ...option, selected: selected } : option,
		);
	}
}
